import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("KMR ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.toString?.() || "Erreur inconnue";
    const stack = this.state.info?.componentStack || this.state.error?.stack || "";
    return (
      <div style={{ minHeight: "100vh", background: "#0A0A0B", color: "#F5F5F0", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "sans-serif" }} data-testid="error-boundary">
        <div style={{ maxWidth: 640, width: "100%", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(212,175,55,0.3)", borderRadius: 16, padding: 32 }}>
          <img src="/logo-kmr.jpg" alt="KMR Event" style={{ height: 48, borderRadius: 8, marginBottom: 20 }} />
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, margin: "0 0 8px", color: "#D4AF37" }}>Un problème est survenu</h1>
          <p style={{ color: "#8a8a80", margin: "0 0 20px", lineHeight: 1.6 }}>
            Une erreur a interrompu l'affichage. Rechargez la page ; si le problème persiste, copiez le message ci-dessous et transmettez-le nous.
          </p>
          <button onClick={() => window.location.reload()} data-testid="error-reload-btn"
            style={{ background: "linear-gradient(90deg,#F2D98D,#B87333)", color: "#0A0A0B", border: "none", borderRadius: 999, padding: "12px 28px", fontWeight: 600, cursor: "pointer", marginBottom: 20 }}>
            Recharger la page
          </button>
          <details style={{ marginTop: 8 }}>
            <summary style={{ cursor: "pointer", color: "#D4AF37", fontSize: 13 }}>Détails techniques</summary>
            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12, color: "#c9c9c0", marginTop: 12, maxHeight: 260, overflow: "auto" }}>{msg}
{stack}</pre>
          </details>
        </div>
      </div>
    );
  }
}
